import { Button } from "@blueprintjs/core";
import { MenuItem2 } from "@blueprintjs/popover2";
import { Select2, Select2Props } from "@blueprintjs/select";
import React from "react";

import { CreateItem } from "./components";
import { Item } from "./components/item";
import { UseSelect } from "./hooks";
import styles from "./select.module.scss";
import { SelectItem } from "./types";
import { filterItem } from "./utils";

export interface SelectProps<TItem extends SelectItem>
  extends UseSelect<TItem>,
    Omit<Select2Props<TItem>, "items" | "onItemSelect" | "itemRenderer" | "createNewItemFromQuery"> {
  placeholder?: string;
  noResultsText?: string;
  createNewItemFromQuery?: (query: string) => TItem;
}

export const Select = <TItem extends SelectItem>({
  items,
  selectedItem,
  onItemSelect,
  isItemSelected,
  placeholder = "Select",
  noResultsText = "No results",
  ...props
}: SelectProps<TItem>) => {
  return (
    <Select2<TItem>
      {...props}
      itemRenderer={(item, itemProps) => (
        <Item key={item.id} item={item} props={{ ...itemProps, selected: isItemSelected(item) }} />
      )}
      items={items}
      onItemSelect={onItemSelect}
      popoverProps={{ minimal: true, popoverClassName: styles.selectPopover, matchTargetWidth: true }}
      noResults={<MenuItem2 disabled={true} text={noResultsText} roleStructure="listoption" />}
      itemPredicate={filterItem}
      resetOnClose
      createNewItemRenderer={CreateItem}
    >
      <Button text={selectedItem?.label || placeholder} alignText={"left"} fill={props.fill} rightIcon="caret-down" />
    </Select2>
  );
};
